import styled from 'styled-components';
import { Theme } from 'styles/theme';

export const Wrapper = styled.div<{ theme: Theme }>`
  display: flex;
  flex-direction: column;
  gap: var(--Section-Margin);

  .page-header {
    margin-top: var(--Grid-Gap);
  }
`;

export const AdContainer = styled.div`
  width: 100%;
  max-width: 878px;
  margin: 0 auto;
`;
